import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { DeliveryColorEntry } from '../models/delivery-activity.models';

export type DeliveryTimeScale = 'week' | 'month';

@Component({
  selector: 'delivery-chart-controls',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './delivery-chart-controls.component.html',
  styleUrls: ['./delivery-chart-controls.component.scss'],
  imports: [MatButtonToggleModule, TranslateModule],
})
export class DeliveryChartControlsComponent {
  readonly colorBy = input<'equipment' | 'operator'>('equipment');
  readonly timeScale = input<DeliveryTimeScale>('week');
  readonly palette = input<DeliveryColorEntry[]>([]);

  readonly colorByChange = output<'equipment' | 'operator'>();
  readonly timeScaleChange = output<DeliveryTimeScale>();
  readonly navigate = output<-1 | 1>();
  readonly todayClick = output<void>();
  readonly datePick = output<Date>();

  protected onDateInputChange(value: string): void {
    if (!value) {
      return;
    }

    const parsed = new Date(`${value}T00:00:00`);
    if (Number.isNaN(parsed.getTime())) {
      return;
    }

    this.datePick.emit(parsed);
  }
}
